"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePostSubscription = void 0;
var _msRestJs = require("@azure/ms-rest-js");
var _auth = require("@ori/auth");
var _axios = require("@ori/axios");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _logger = require("@ori/logger");
var _axiosCaseConverter = _interopRequireDefault(require("axios-case-converter"));
var _react = require("react");
var _contexts = require("../contexts");
var _types = require("../types");
var _getSafeUrl = require("../utils/getSafeUrl");
/* eslint-disable @typescript-eslint/naming-convention -- headers */

const client = (0, _axiosCaseConverter.default)(_axios.axios.create(), {
  // preserve keys in translations that represent locales, e.g. en-GB, ka-GE
  preservedKeys: input => /^[A-Za-z]{2}-[A-Za-z]{2}$/.test(input),
  caseFunctions: {
    // overrides built-in snake function to keep the keys of outcoming data in camelCase
    snake: input => input.replaceAll(/[^\dA-Za-z]+(.)/g, (_, char) => char.toUpperCase())
  }
});
const usePostSubscription = () => {
  const {
    customerId,
    onClose,
    onSave,
    onError,
    handleOpenFeedback,
    placement,
    productCode,
    uriTemplate
  } = (0, _react.useContext)(_contexts.wizardContext);
  const {
    selectedPackage
  } = (0, _react.useContext)(_contexts.stateContext);
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi']);
  const logger = (0, _logger.useLogger)('usePostSubscription');
  const postSubscription = async formValues => {
    const subscriptionInstructionsToPost = {
      newConsumer: formValues.existingCustomerId === undefined ? {
        firstName: formValues.customerFirstName,
        lastName: formValues.customerSurname
      } : undefined,
      existingConsumerId: formValues.existingCustomerId ?? undefined,
      packageId: selectedPackage ? selectedPackage.packageId : 0,
      status: 'Finished'
    };
    try {
      const subscriptionInstructionsUrl = (0, _getSafeUrl.getSafeUrl)(`/customers/${customerId}/subscriptionInstructions`, globalApiUrl);
      const {
        data
      } = await client.post(subscriptionInstructionsUrl, {
        ...subscriptionInstructionsToPost
      }, {
        headers: {
          'Content-Type': 'application/json',
          'x-placement': placement,
          'x-referer': uriTemplate,
          'x-tenant-context': tenant,
          authorization: formattedToken
        }
      });
      onSave({
        detail: {
          type: _types.EWizardType.Subscription,
          productCode,
          subscriptionId: Number(data.newSubscriptionId)
        }
      });
      onClose();
      handleOpenFeedback();
    } catch (error) {
      logger.error(error, {
        action: 'postSubscription'
      });
      if (error instanceof _msRestJs.RestError) {
        onError({
          detail: {
            type: _types.EWizardType.Subscription,
            error: {
              code: Number(error.response?.status),
              message: String(error.body)
            }
          }
        });
        onClose();
      }
    }
  };
  return {
    postSubscription
  };
};
exports.usePostSubscription = usePostSubscription;
